import clsx from "clsx";
import { useTranslation } from "react-i18next";

export default function ResourceSection() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === "zh";
  const resources = t("home.resource.items", {
    returnObjects: true,
  }) as Array<{ title: string; paragraphs: string[] }>;

  return (
    <div className="bg-[#0f5f95] relative w-full pt-10 md:pt-[60px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <h2
          data-aos-delay="100"
          data-aos="fade-up"
          className="font-bold text-white text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
        >
          {t("home.resource.title")}
        </h2>
        <p data-aos="fade-up" className="text-center text-white text-[15px] md:text-[18px] leading-relaxed px-2">
          {t("home.resource.subtitle")}
        </p>
        <div className="py-8 md:py-[60px] relative w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-[2%]">
          {resources.map((item, index) => {
            const iconIndex = String(index + 14).padStart(2, "0");
            const iconUrl = `images/index${iconIndex}.png`;

            return (
              <div
                key={index}
                className="bg-white h-full px-4 pb-8 md:pb-10"
                data-aos="zoom-in-up"
              >
                <i
                  className="bg-no-repeat bg-center bg-contain w-[80px] h-[80px] md:w-[100px] md:h-[100px] rounded-full bg-[#0f5f95] block mx-auto mt-8 md:mt-[50px] mb-5 md:mb-[30px]"
                  style={{ backgroundImage: `url(${iconUrl})` }}
                ></i>
                <h3 className="text-[#222] text-[20px] md:text-[24px] font-bold text-center pb-[12px] md:pb-[15px] leading-snug">
                  {item.title}
                </h3>
                <p
                  className={clsx(
                    "leading-[24px]",
                    "text-[#666]",
                    "text-center",
                    "text-[15px] md:text-[16px]",
                    isZh ? "whitespace-pre-line" : ""
                  )}
                >
                  {item.paragraphs.join("\n")}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
